import React, { Component } from 'react';
import format from 'string-format';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import { withMessage } from '../Common/Message';
import RecommendationContainer from '../Common/Recommendation/Container';
import resx from '../../utilities/resx';
import loggly from '../../API/Loggly';
import { RESX_REBLASTS, RESX_GLOBAL, LOGGLY_LEVEL_ERROR } from '../../Constants';

class RecommendationAdapter extends Component {
	constructor() {
		super();
		this.state = {
			iconName: '',
			contentText: '',
			url: '',
			buttonText: '',
			mixPanelContext: '',
			mixPanelType: ''
		};
	}

	componentDidMount() {
		this.adaptData();
	}

	adaptData() {
		if (!window.reblastDetails) {
			this.props.message.addMessage({ message: resx(RESX_GLOBAL, 'GENERIC_WEBSERVICE_ERROR_MESSAGE'), type: 'error' });
			loggly.add(LOGGLY_LEVEL_ERROR, 'the window.reblastDetails object is undfined in reblsat details page');
			return false;
		}
			const { ContentType, ListingIsSold } = window.reblastDetails;
			let data;
			switch (ContentType) {
				case 'Listing':
					if (ListingIsSold === 'True') {
						data = this.getSoldListingData();
					} else {
						data = this.getListingData();
					}
					break;
				case 'Referral':
					data = this.getReferralData();
					break;
				case 'PreMarketListing':
					data = this.getPreMarketListingData();
					break;
				default:
					break;
			}

			if (!data) {
				data = this.getContentTypeUnknownState();
			}

			if (data) {
				 this.setState(data);
		}

	}

	getPreMarketListingData = () => {
		const { ListingCity, ListingState, ListingLongitude, ListingLatitude } = window.reblastDetails;
		if (!ListingCity || !ListingState || !ListingLongitude || !ListingLatitude) {
			return false;
		}
		const address = `${ListingCity}, ${ListingState}`;
		return {
			iconName: 'clock',
			contentText: format(resx(RESX_REBLASTS, 'RECOMMENDATION_SEE_COMING_SOON_LISTINGS'), ListingCity, ListingState),
			url: `${
				RESAAS.Environment.ApplicationUrl
			}/listings?&rtf=0&mnp=&mxp=&pr=&mnb=Bedrooms&mnba=Bathrooms&ls=3&z=12&la=${ListingLatitude}&lo=${ListingLongitude}&gn=&st=1&address=${encodeURIComponent(
				address
			)}`,
			buttonText: format(resx(RESX_REBLASTS, 'RECOMMENDATION_VIEW_LISTINGS')),
			mixPanelContext: 'pre-market Listing',
			mixPanelType: 'reblast CTA'
		};
	}

	getSoldListingData = () => {
		const { FirstName, UserDomain } = window.reblastDetails;
		if (!FirstName || !UserDomain) {
			return false;
		}
		return {
			iconName: 'dollar-sign',
			contentText: format(resx(RESX_REBLASTS, 'RECOMMENDATION_SEE_MORE_USER_LISTINGS'), FirstName),
			url: `${RESAAS.Environment.ApplicationUrl}/${UserDomain}/listings`,
			buttonText: format(resx(RESX_REBLASTS, 'RECOMMENDATION_VIEW_PROFILE')),
			mixPanelContext: 'sold listing',
			mixPanelType: 'reblast CTA'
		};
	}

	getListingData = () => {
		const { ListingCity, ListingState, ListingLongitude, ListingLatitude } = window.reblastDetails;
		if (!ListingCity || !ListingState || !ListingLongitude || !ListingLatitude) {
			return false;
		}
		const address = `${ListingCity}, ${ListingState}`;
		return {
			iconName: 'location',
			contentText: format(resx(RESX_REBLASTS, 'RECOMMENDATION_SEE_MORE_LISTINGS'), ListingCity, ListingState),
			url: `${
				RESAAS.Environment.ApplicationUrl
			}/listings?&rtf=0&mnp=&mxp=&pr=&mnb=Bedrooms&mnba=Bathrooms&ls=0&z=12&la=${ListingLatitude}&lo=${ListingLongitude}&gn=&st=1&address=${encodeURIComponent(
				address
			)}`,
			buttonText: format(resx(RESX_REBLASTS, 'RECOMMENDATION_VIEW_LISTINGS')),
			mixPanelContext: 'on-market Listing',
			mixPanelType: 'reblast CTA'
		};
	}

	getReferralData = () => {
		const ReblastDescription = window.reblastDetails.ReblastDescription;
		const newElement = document.createElement('div');
		newElement.innerHTML = ReblastDescription;
		const element = newElement.getElementsByTagName('a')[0];
		let html;
		let url;

		if (element) {
			html = element.innerHTML;
			url = element.getAttribute('href');
		}

		if (!html || !url) {
			return false;
		}

		return {
			iconName: 'referral re-icon-custom',
			contentText: format(resx(RESX_REBLASTS, 'RECOMMENDATION_SEE_MORE_REFERRAL'), html),
			url,
			buttonText: format(resx(RESX_REBLASTS, 'RECOMMENDATION_VIEW_NOW')),
			mixPanelContext: 'referral/buyer need upsell',
			mixPanelType: 'reblast CTA'
		};
	}

	getContentTypeUnknownState = () => {
        const isPremiumUser = _path(['RESAAS', 'User2', 'ReferralPro'], window);
		const reblastDescription = _path(['reblastDetails', 'ReblastDescription'], window);
		const isMsgPremiumJoin = (typeof reblastDescription === 'string') ? reblastDescription.indexOf('www.resaas.com/pricing') >= 0 : false;

		// show premium upsell if user is not currently premium and reblast desc contains a link to pricing page
		if (!isPremiumUser && isMsgPremiumJoin) {
			return {
				iconName: 'resaas-black re-icon-custom',
				contentText: resx(RESX_REBLASTS, 'RECOMMENDATION_PREMIUM_UPSELL'),
				url: '/pricingplan',
				buttonText: resx(RESX_GLOBAL, 'DEFAULT_SUBSCRIPTION_GET_STARTED'),
				mixPanelContext: 'premium upsell',
				mixPanelType: 'reblast CTA'
			};
		}

		const { FirstName, LastName, UserDomain, ContentType } = window.reblastDetails;
		const name = `${FirstName} ${LastName}`;
		const type = ContentType === 'Unknown' ? 'text' : ContentType.toLowerCase();
		if (!FirstName || !LastName || !UserDomain) {
			return false;
		}
		return {
			iconName: 'attach-image',
			contentText: format(resx(RESX_REBLASTS, 'RECOMMENDATION_CHECK_OUT_POSTS'), name),
			url: `/${UserDomain}/profile`,
			buttonText: resx(RESX_REBLASTS, 'RECOMMENDATION_VIEW_PROFILE'),
			mixPanelContext: `new ${type} post`,
			mixPanelType: 'reblast CTA'
		};		
	}

	render() {
		if (!this.state.url) {
			return null;
		}
		return (
			<RecommendationContainer data={this.state} />
		);
	}
}

export default withMessage(RecommendationAdapter);

RecommendationAdapter.propTypes = {
	message: PropTypes.object
};
